import { styled } from '@mui/material/styles';
import MuiButton from '@mui/material/Button';

export const Root = styled('div', {
  shouldForwardProp: prop => prop !== 'variant'
})<{ variant?: 'active' | 'finalized' }>(({ theme, variant }) => ({
  backgroundColor: variant === 'finalized' ? 'transparent' : theme.palette.neutrals.beige2,
  border: variant === 'finalized' ? `1px solid ${theme.palette.neutrals.beige4}` : 'none',
  borderRadius: '8px',
  padding: '16px',
  display: 'flex',

  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'flex-start',

  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column'
  }
}));

export const Body = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5)
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5)
}));

export const InfoGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const ViewDetails = styled(MuiButton)(({ theme }) => ({
  marginTop: 0,
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(2)
  }
}));
